<script lang="ts">
	import { DropdownPosition } from './DropdownPosition'
	import { BoxBorderShadow } from '@repo/ui'
	import { type Snippet } from 'svelte'

	interface Props {
		full?: boolean
		portal?: boolean
		position?: DropdownPosition
		children?: Snippet
	}

	let {
		full = false,
		portal = false,
		position = DropdownPosition.Right,
		children,
	}: Props = $props()
</script>

<div
	class="{portal ? '' : 'absolute top-full z-20 mt-1'} {full ? 'w-full' : 'mr-2'}"
	class:left-0={!portal && position === DropdownPosition.Left}
	class:right-0={!portal && position === DropdownPosition.Right}
>
	<BoxBorderShadow {full}>
		{@render children?.()}
	</BoxBorderShadow>
</div>
